import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=65bf1ec2&scoped=true"
import script from "./FilterList.vue?vue&type=script&lang=js"
export * from "./FilterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf1ec2",
  null
  
)

export default component.exports